import { render, staticRenderFns } from "./RechargeRecord.vue?vue&type=template&id=f6b1d0d6&scoped=true&"
import script from "./RechargeRecord.vue?vue&type=script&lang=js&"
export * from "./RechargeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b1d0d6",
  null
  
)

export default component.exports